import React, { useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { Actions as EMPLOYEEACTIONS } from "../../../../store/actions/employeeActions";
import "react-datepicker/dist/react-datepicker.css";
import { format, addMonths } from "date-fns";
import {
	ArrowDownTrayIcon,
	ArrowLeftIcon,
	ArrowRightIcon,
	ArrowUpTrayIcon, BellAlertIcon,
	CheckIcon, ForwardIcon,
	XMarkIcon
} from "@heroicons/react/20/solid";
import ImportEmployeeRow from "./ImportEmployeeRow";
import { CSVLink } from "react-csv";
import Spinner from "../../../common/Spinner";
import ImportedEmployeeRow from "./ImportedEmployeeRow";
import { FileUploader } from "react-drag-drop-files";
import { Cog8ToothIcon, DocumentArrowUpIcon } from "@/icons/solid";
import Tooltip from "@/tooltip";
import BuddySelector from "buddy/selector";
import ImportFieldColumn from "@/components/employees/modals/import-employee-modal/ImportFieldColumn";

const ImportFieldMapper = ({
	headers,
	fields,
	importType,
	sampleRows,
	missingRequiredFields,
	innerMapping,
    updateFieldMapping,
    updateInnerFieldMapping,
	updateMappingDefaultValue
}) => {
	const [sampleRow, setSampleRow] = useState(0);

	return (
		<>
			<div className="section-header">
				<h1>Confirm Your Data Mapping</h1>
			</div>
			<table id="active-people-table" className="js-table-sections table table-hover">
				<thead className={"sticky top-0 backdrop-blur-sm z-40"}>
					<tr>
						<th>Header</th>
						<th>Mapping</th>
						<th>
							<span className={"relative"}>
								{/* if index is 0 do not show arrow before*/}
								<ArrowLeftIcon
									className={`w-5 h-5 mr-1 ${sampleRow !== 0 ? "cursor-pointer" : "cursor-not-allowed opacity-45"}`}
									onClick={() => sampleRow !== 0 && setSampleRow(sampleRow - 1)}
								/>
								Sample
								{/* if index is last do not show arrow after*/}
								<ArrowRightIcon
									className={`w-5 h-5 mr-1 ${sampleRow !== sampleRows.length - 1 ? "cursor-pointer" : "cursor-not-allowed opacity-45"}`}
									onClick={() => sampleRow !== sampleRows.length - 1 && setSampleRow(sampleRow + 1)}
								/>
								<br/>
								<span className={"absolute left-0 text-center mt-0 text-xs"}>
									Row {sampleRow + 1} of {sampleRows.length}
								</span>
							</span>


						</th>
						<th>Status</th>
					</tr>
				</thead>
				<tbody>
					{headers.map((column, index) => (
						<ImportFieldColumn index={index} importType={importType} sampleRow={sampleRow} />
					))}
				</tbody>
			</table>


			{missingRequiredFields.length > 0 &&
				<>
					<div className="section-header">
						<h1>Set Default Values for missing Required Fields</h1>
					</div>
					<table id="active-people-table" className="js-table-sections table table-hover">
						<thead className={"sticky top-0 backdrop-blur-sm z-40"}>
							<tr>
								<th>Field</th>
								<th>Default Value</th>
							</tr>
						</thead>
						<tbody>
							{missingRequiredFields.map((column, index) => {
								return (
									<tr key={column.field}>
										<td>
											{column.name}
										</td>
										<td>
											<BuddySelector
												options={column.options}
												isClearable={true}
												/*value={value?.item}*/
												onChange={(item) => {
													updateMappingDefaultValue({column,item})
												}}
											  />
										</td>
									</tr>
								)
							})}
						</tbody>
					</table>
				</>
			}
		</>
	);
};

const mapStateToProps = (state) => {

	const {headers, fields, sampleRows, innerMapping} = state.employees.uploadMapping ?? {};

	const selectableFields = fields.map(group => {
		return {
			label: group.name,
			options: group.options.map(option => {
				return {
					label: option.name,
					value: option.field,
					group: group.name,
                    innerOptions: option.options?.map(innerOption => {
                        return {
                            label: innerOption.label,
                            value: innerOption.value,
                        }
                    }),
				};
			}),
		}
	})

	const missingRequiredFields = [];

	fields.map(group => group.options.map(option => {
		if (option.required === true && !option.hidden && headers.find(header => header && header?.matchedField?.field === option.field && header?.matchedField?.groupName === group.name ) === undefined) {
			option.group = group.name;
			missingRequiredFields.push(option);
		}
	}))

	return {
		headers,
		fields: selectableFields,
		sampleRows,
		innerMapping,
		missingRequiredFields,
		jurisdiction: state.company?.settings?.jurisdiction,
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(EMPLOYEEACTIONS.toggleImportModal()),
    updateFieldMapping: (input) => dispatch(EMPLOYEEACTIONS.employeeUpdateFieldMapping(input)),
    updateInnerFieldMapping: (input) => dispatch(EMPLOYEEACTIONS.employeeUpdateInnerMapping(input)),
    updateMappingDefaultValue: (input) => dispatch(EMPLOYEEACTIONS.employeeUpdateMappingDefaultValue(input)),
	uploadFile: (file, agreement) => dispatch(EMPLOYEEACTIONS.uploadFile({ file, agreement })),
	employeesGetListWithSalary: () =>
		dispatch(
			EMPLOYEEACTIONS.employeesGetListWithSalary({
				from: format(addMonths(new Date(), -2), "yyyy-MM-01"), // get list from last 2 months
				to: format(new Date(), "yyyy-12-31"),
			}),
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportFieldMapper);
